import React from 'react';

import {storesContext} from '../stores/root.store';

export const useStores = () => React.useContext(storesContext);
